import Swal from 'sweetalert2';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import GalleryIcon from '../icons/gallery.svg';

import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';

export default class Gallery extends Plugin {
    static get requires() {
        return [MediaEmbed];
    }

    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('gallery', (locale) => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Coloque o id da galeria',
                icon: GalleryIcon,
                tooltip: true,
            });

            // Callback executed once the gallery is clicked.
            view.on('execute', async () => {
                const { value: id } = await Swal.fire({
                    input: 'text',
                    inputPlaceholder: 'Coloque o ID da galeria',
                });

                if (id) {
                    editor.model.change(() => {
                        const content = ` <p>[template="galery" mediaid="${id}"]</p>`;

                        const viewFragment = editor.data.processor.toView(content);
                        const modelFragment = editor.data.toModel(viewFragment);

                        editor.model.insertContent(
                            modelFragment,
                            editor.model.document.selection
                        );
                    });
                }
            });

            return view;
        });
    }
}
